// Vite provided environment variables
export const ENV_VITE_DEV = import.meta.env.DEV

// Custom environment variables
export const ENV_MOCK_MODE = import.meta.env.VITE_MOCK_MODE
export const ENV_APP_VERSION = import.meta.env.VITE_APP_VERSION ?? 'N/A'

// Just the base path portion
export const ENV_CCC_QUEUE_BASE_PATH =
  import.meta.env.VITE_CCC_QUEUE_BASE_PATH ?? '/'
// Base url = origin + base path
export const ENV_CCC_MAIN_BASE_URL =
  import.meta.env.VITE_CCC_MAIN_BASE_URL ?? 'NOT_FOUND_VITE_CCC_MAIN_BASE_URL'
export const ENV_INTERNAL_BFF_URL =
  import.meta.env.VITE_INTERNAL_BFF_URL ?? 'NOT_FOUND_VITE_INTERNAL_BFF_URL'
export const ENV_INTERNAL_SIGNALR_URL =
  import.meta.env.VITE_INTERNAL_SIGNALR_URL ??
  'NOT_FOUND_VITE_INTERNAL_SIGNALR_URL'
export const ENV_OLD_CCC_QUEUE_BASE_URL =
  import.meta.env.VITE_OLD_CCC_QUEUE_BASE_URL ??
  'NOT_FOUND_VITE_OLD_CCC_QUEUE_BASE_URL'
